'use strict';

import getProp from 'shared/js/util/get';

const getConfig = () => {
    const prefs = window.SitePreferences || {};
    return prefs.FEATURE_FLAGS || {};
};

/**
 * @param {string|string[]} key
 * @param {*} [defaults]
 * @returns {*}
 */
const get = (key, defaults) => {
    key = Array.isArray(key) ? key : key.split('.');
    return getProp(getConfig(), key, defaults);
};

/**
 * @returns {string}
 */
const getCurrentSite = () => {
    const prefs = window.SitePreferences || {};
    return (prefs.SITE_CODE || getConfig().site || '').toUpperCase();
};

/**
 * @param {...string} sites
 * @returns {boolean}
 */
const isSite = (...sites) => {
    if (sites.length === 1 && Array.isArray(sites[0])) {
        sites = sites[0];
    }
    const currentSite = getCurrentSite();
    return sites.some(
        (cValue) => currentSite === cValue.toUpperCase()
    );
};

export default {
    get,
    getCurrentSite,
    isSite
};

export { get, getCurrentSite, isSite };
